import TagManager from 'react-gtm-module';
import {
  DoseAtDay,
  TwoDosesAtDay,
  ThreeDosesAtDay,
  FourDosesAtDay,
  FiveDosesAtDay,
  SixDosesAtDay,
  DosesAtDay,
} from 'components/icon';

function subscribe(eventName, listener) {
  document.addEventListener(eventName, listener);
}

function unsubscribe(eventName, listener) {
  document.removeEventListener(eventName, listener);
}

function publish(eventName) {
  const event = new CustomEvent(eventName);
  document.dispatchEvent(event);
}

function publishWithParams(eventName, params) {
  const event = new CustomEvent(eventName, params);
  document.dispatchEvent(event);
}

function getFilenameExtension(contentType) {
  const map = {
    'image/jpeg': '.jpeg',
    'image/pjpeg': '.jpeg',
    'image/png': '.png',
    'image/x-png': '.png',
    'application/pdf': '.pdf',
    'video/mp4': '.mp4',
    'application/octet-stream': '.mp4',
    'text/plain': '.txt',
  };

  return map[contentType] || '';
}

function base64ToBlob(base64, type) {
  const binaryString = window.atob(base64);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; ++i) {
    bytes[i] = binaryString.charCodeAt(i);
  }

  return new Blob([bytes], { type: type });
}

function logAnalyticsEvent(eventData, step) {
  const dataLayerPayload = {
    event: 'ga4_event',
    ...eventData,
  };

  if (step !== undefined && step !== null) {
    dataLayerPayload.step = step;
  }

  console.log('dataLayerPayload-->', dataLayerPayload);

  TagManager.dataLayer({ dataLayer: dataLayerPayload });
}

function GetMinutes(d) {
  let today = new Date();
  let diffMs = new Date(d) - today;
  let diffDays = Math.floor(diffMs / 86400000);
  let diffHrs = Math.floor((diffMs % 86400000) / 3600000);
  let diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000);
  return {
    days: diffDays,
    hours: diffHrs,
    mins: diffMins,
  };
}

const getMarginPagesDisplayed = width => {
  if (width < 375) return 1;
  if (width < 825) return 2;
  return 3;
};

const getPageRangeDisplayed = width => {
  if (width < 375) return 1;
  if (width < 825) return 2;
  return 2;
};

function getItemDoseAtDayIcon(doseAtDay) {
  switch (doseAtDay) {
    case 1:
      return <DoseAtDay />;
    case 2:
      return <TwoDosesAtDay />;
    case 3:
      return <ThreeDosesAtDay />;
    case 4:
      return <FourDosesAtDay />;
    case 5:
      return <FiveDosesAtDay />;
    case 6:
      return <SixDosesAtDay />;
    default:
      return <DosesAtDay />;
  }
}

const encodeURL = name => {
  return name
    .toLowerCase()
    .replace(/ı/g, 'i')
    .replace(/ğ/g, 'g')
    .replace(/ü/g, 'u')
    .replace(/ö/g, 'o')
    .replace(/ç/g, 'c')
    .replace(/ş/g, 's')
    .replace(/[^a-z0-9\s-]/g, '')
    .trim()
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-');
};

export {
  publish,
  subscribe,
  unsubscribe,
  publishWithParams,
  getFilenameExtension,
  base64ToBlob,
  logAnalyticsEvent,
  GetMinutes,
  getMarginPagesDisplayed,
  getPageRangeDisplayed,
  getItemDoseAtDayIcon,
  encodeURL,
};
